import {
  Injectable
} from "@angular/core";

@Injectable()
export class AddOrderServiceProvider {
  searched_product: any;
  all_projects: any = [];
  pre_projects: any = [];

  mySelectedIndex: any = 0;

  public percent: number;

  all_village_list: any = [];

  is_multiple_pincode = false;
  is_multiple_address = false;

  finalAction: boolean = false;

  newmissingAddress: boolean = false;

  temp_all_projects: any = [];
  popoverTitle: any = "Delete";
  popoverMessage: any = "Are you sure?";
  public hascartinfo: any = false;

  orderpopoverTitle: any = "Are you sure?";
  orderpopoverMessage: any = "Please confirm your order information!";

  external_mobile_number: any = null;

  assignee: any = [];
  masterAddressId: any = false;

  orderData: any = {
    grand_total: 0,
    sub_total: 0,
    gram_cash: 0,
    additional_discount: 0,
    total_additional_discount: 0,
    coupon_id: "",
    coupon_discount: 0,
    credit_order: false
  };

  isPlaceOrderIsRunning = false;

  all_state: any = [];
  all_district: any = [];
  all_tehsil: any = [];
  all_village: any = [];
  all_pincode: any = [];

  m_all_state: any = [];
  m_all_district: any = [];
  m_all_tehsil: any = [];
  m_all_village: any = [];

  disableOtherTabs: boolean = false;

  district_active = false;
  tehsil_active = false;
  village_active = false;

  isPlacedOrderClicked: boolean = false;

  public address_list = [];
  public moreThanOneAddress = false;
  all_added_products: any = [];

  all_status: any = [];

  all_assigned_to: any = [];
  all_crops: any = [];

  former_types: any = [];
  list_crops: any = [];
  query_types: any = [];

  prospectId: number;
  selectedTab: string;
  dynamicId: any = null;

  public postData: any = {
    status: 7,
    source: "Gram Uday",
    searchpincode: null,
    customer_id: "",
    opportunity_id: null,
    alternate_mobile_no: "",
    last_name: "",
    father_first_name: "",
    father_last_name: "",
    state: "",
    district: "",
    tehsil: "",
    village: "",
    product_data: {},
    mobile_no: "",
    first_name: "",
    assigned_to: "",
    order_details: "",
    customer_details: {
      irrigation_details: "",
      total_area: "",
      crops: [],
      farmer_type: "",
      mobile_type: "smart",
      equipments: [],
      use_whatsapp: "yes",
      comments: "",
      whataspp_no_same: "yes",
      sms_alert: "yes",
      customer_id: "",
      add_on_whatsapp: "yes"
    },
    products: [],
    query: {
      query_category: "",
      query_crop: "",
      query: ""
    },
    place_order: "no"
  };

  public missingAddressData: any = {
    state: "",
    district: "",
    tehsil: "",
    village: "",
    pincode: ""
  };

  reassignData() {
    this.postData = {
      customer_id: "",
      source: "Gram Uday",
      opportunity_id: null,
      state: "",
      district: "",
      first_name: this.postData.first_name,
      last_name: this.postData.last_name,
      father_first_name: this.postData.father_first_name,
      father_last_name: this.postData.father_last_name,
      alternate_mobile_no: this.postData.alternate_mobile_no,
      tehsil: "",
      mobile_no: this.postData.mobile_no,
      village: "",
      product_data: {},
      order_details: "",
      customer_details: {
        irrigation_details: "",
        total_area: "",
        crops: [],
        farmer_type: "",
        mobile_type: "smart",
        equipments: [],
        use_whatsapp: "yes",
        comments: "",
        whataspp_no_same: "yes",
        sms_alert: "yes",
        customer_id: "",
        add_on_whatsapp: "yes"
      },
      products: [],
      query: {
        query_category: "",
        query_crop: "",
        query: ""
      },
      place_order: "no"
    };
  }

  reInitializeData() {
    this.disableOtherTabs = false;
    this.newmissingAddress = false;

    this.pre_projects = [];
    this.hascartinfo = false;

    this.orderData = {
      grand_total: 0,
      gram_cash: 0,
      sub_total: 0,
      additional_discount: 0,
      total_additional_discount: 0,
      coupon_id: "",
      coupon_discount: 0,
      credit_order: false
    };

    this.missingAddressData = {
      state: "",
      district: "",
      tehsil: "",
      village: "",
      pincode: ""
    };

    this.postData = {
      status: 7,
      source: "Gram Uday",
      searchpincode: null,
      customer_id: "",
      opportunity_id: null,
      alternate_mobile_no: "",
      last_name: "",
      father_first_name: "",
      father_last_name: "",
      state: "",
      district: "",
      tehsil: "",
      village: "",
      product_data: {},
      mobile_no: "",
      first_name: "",
      assigned_to: "",
      order_details: "",
      customer_details: {
        irrigation_details: "",
        total_area: "",
        crops: [],
        farmer_type: "",
        mobile_type: "smart",
        equipments: [],
        use_whatsapp: "yes",
        comments: "",
        whataspp_no_same: "yes",
        sms_alert: "yes",
        customer_id: "",
        add_on_whatsapp: "yes"
      },
      products: [],
      query: {
        query_category: "",
        query_crop: "",
        query: ""
      },
      place_order: "no"
    };
  }

  clear() {
    this.missingAddressData = {
      state: "",
      district: "",
      tehsil: "",
      village: "",
      pincode: ""
    };

    this.disableOtherTabs = false;

    this.pre_projects = [];

    this.orderData = {
      grand_total: 0,
      sub_total: 0,
      gram_cash: 0,
      additional_discount: 0,
      total_additional_discount: 0,
      coupon_id: "",
      coupon_discount: 0,
      credit_order: false
    };

    this.postData = {
      status: 7,
      source: "Gram Uday",
      searchpincode: null,
      customer_id: "",
      opportunity_id: null,
      alternate_mobile_no: "",
      last_name: "",
      father_first_name: "",
      father_last_name: "",
      state: "",
      district: "",
      tehsil: "",
      village: "",
      product_data: {},
      mobile_no: "",
      first_name: "",
      assigned_to: "",
      order_details: "",
      customer_details: {
        irrigation_details: "",
        total_area: "",
        crops: [],
        farmer_type: "",
        mobile_type: "smart",
        equipments: [],
        use_whatsapp: "yes",
        comments: "",
        whataspp_no_same: "yes",
        sms_alert: "yes",
        customer_id: "",
        add_on_whatsapp: "yes"
      },
      products: [],
      query: {
        query_category: "",
        query_crop: "",
        query: ""
      },
      place_order: "no"
    };
  }
}


// WEBPACK FOOTER //
// ./src/pages/addorder/add-order.service.ts